import React from 'react';
import SkillBadge from '../../../common/skillBadge';

const InfoRow = ({ label, value }) => (
  <div className="grid grid-cols-2 text-xs">
    <span className="text-gray-999">{label}</span>
    <span className="font-semibold text-gray-333">{value}</span>
  </div>
);

const OtherJobCard = ({ job }) => {
  return (
    <div className="bg-white p-4 rounded-xl shadow-md transition-shadow">
      <h4 className="font-bold text-gray-333">{job.title}</h4>
      <p className="text-xs text-gray-999">{job.company}</p>
      <div className="space-y-2 mt-3 pt-3 border-t border-gray-100">
        <InfoRow label="Job ID" value={job.jobId} />
        <InfoRow label="Posted on" value={job.postedOn} />
        <InfoRow label="Location" value={job.location} />
        <InfoRow label="Experience required" value={job.experience} />
        <InfoRow label="Vacancies" value={job.vacancies} />
        <InfoRow label="Application Deadline" value={job.deadline} />
        <div className="grid grid-cols-2 text-xs">
          <p className="text-xs text-gray-999">Skills & Expertise required</p>
          <div className="flex flex-wrap gap-2 mt-2">
            {job.skills.map(skill => (
              <SkillBadge key={skill}>{skill}</SkillBadge>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherJobCard;